import React, { memo } from 'react'
import { useNutritionItem, NutritionItemProps } from './useNutritionItem'
import styles from './NutritionItem.module.scss'

const NutritionItem: React.FC<NutritionItemProps> = (
  props: NutritionItemProps
) => {
  const { title, item, unit } = useNutritionItem(props)

  return (
    <div className={styles.nutrition}>
      <span className={styles.title}>{title}&nbsp;</span>
      <span className={styles.item}>
        {item}
        {unit}
      </span>
    </div>
  )
}

export default memo(NutritionItem)
